import { render, staticRenderFns } from "./RankingCreateUpdate.vue?vue&type=template&id=5d63f094&scoped=true&"
import script from "./RankingCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RankingCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RankingCreateUpdate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingCreateUpdate.vue?vue&type=style&index=1&id=5d63f094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63f094",
  null
  
)

export default component.exports